/* eslint-disable */
require('./add')
require('./arrow-left')
require('./arrow-reduir')
require('./arrow-right-icon')
require('./arrow-right')
require('./arrow-top')
require('./arrow')
require('./block')
require('./bonhomme')
require('./burger')
require('./calendar-icon')
require('./cards')
require('./carte-bleue')
require('./chat')
require('./checked')
require('./close')
require('./colocataires')
require('./crayon')
require('./credit-card')
require('./cross')
require('./customer-service')
require('./date')
require('./delete')
require('./download')
require('./env-beach')
require('./env-city')
require('./env-countryside')
require('./env-mountain')
require('./enveloppe')
require('./euro')
require('./fast')
require('./groupe-of-person')
require('./groupe')
require('./happy')
require('./help')
require('./home-tick')
require('./home')
require('./journal')
require('./keys')
require('./leave-groupe')
require('./left')
require('./lock')
require('./logo-oo')
require('./maison')
require('./mastercard')
require('./menu-burger')
require('./menu-horizontal')
require('./menu')
require('./none')
require('./ok')
require('./other')
require('./pen')
require('./picto-ajouter-photo-de-profil')
require('./picto-favoris-logement')
require('./picto-indifferent')
require('./picto-logement-false')
require('./picto-logement-true')
require('./picto-profil-activites-artistiques-0')
require('./picto-profil-activites-artistiques-1')
require('./picto-profil-activites-artistiques-2')
require('./picto-profil-activites-artistiques-3')
require('./picto-profil-activites-artistiques-4')
require('./picto-profil-activites-artistiques-5')
require('./picto-profil-activites-artistiques-6')
require('./picto-profil-activites-artistiques-7')
require('./picto-profil-alimentation-10')
require('./picto-profil-alimentation-11')
require('./picto-profil-alimentation-5')
require('./picto-profil-alimentation-6')
require('./picto-profil-alimentation-7')
require('./picto-profil-alimentation-8')
require('./picto-profil-alimentation-9')
require('./picto-profil-animaux-1')
require('./picto-profil-animaux-2')
require('./picto-profil-animaux-3')
require('./picto-profil-animaux-4')
require('./picto-profil-animaux-5')
require('./picto-profil-animaux-6')
require('./picto-profil-animaux-7')
require('./picto-profil-decoration-1')
require('./picto-profil-decoration-10')
require('./picto-profil-decoration-11')
require('./picto-profil-decoration-12')
require('./picto-profil-decoration-13')
require('./picto-profil-decoration-14')
require('./picto-profil-decoration-15')
require('./picto-profil-decoration-2')
require('./picto-profil-decoration-3')
require('./picto-profil-decoration-4')
require('./picto-profil-decoration-5')
require('./picto-profil-decoration-6')
require('./picto-profil-decoration-7')
require('./picto-profil-decoration-8')
require('./picto-profil-decoration-9')
require('./picto-profil-fumeur-11')
require('./picto-profil-fumeur-2')
require('./picto-profil-fumeur-5')
require('./picto-profil-passion-1')
require('./picto-profil-passion-10')
require('./picto-profil-passion-2')
require('./picto-profil-passion-3')
require('./picto-profil-passion-4')
require('./picto-profil-passion-5')
require('./picto-profil-passion-6')
require('./picto-profil-passion-7')
require('./picto-profil-passion-8')
require('./picto-profil-passion-9')
require('./picto-profil-question-look-1')
require('./picto-profil-question-look-10')
require('./picto-profil-question-look-2')
require('./picto-profil-question-look-3')
require('./picto-profil-question-look-4')
require('./picto-profil-question-look-5')
require('./picto-profil-question-look-6')
require('./picto-profil-question-look-7')
require('./picto-profil-question-look-8')
require('./picto-profil-question-look-9')
require('./picto-profil-repas-11')
require('./picto-profil-repas-14')
require('./picto-profil-repas-2')
require('./picto-profil-repas-5')
require('./picto-profil-repas-8')
require('./picto-profil-rythme-vie-11')
require('./picto-profil-rythme-vie-14')
require('./picto-profil-rythme-vie-2')
require('./picto-profil-rythme-vie-5')
require('./picto-profil-rythme-vie-8')
require('./picto-profil-situation-11')
require('./picto-profil-situation-2')
require('./picto-profil-situation-5')
require('./picto-profil-situation-8')
require('./picto-profil-week-end-10')
require('./picto-profil-week-end-5')
require('./picto-profil-week-end-6')
require('./picto-profil-week-end-7')
require('./picto-profil-week-end-8')
require('./picto-profil-week-end-9')
require('./picto-tablo-bord-abonnement')
require('./picto-tablo-bord-blog')
require('./picto-tablo-bord-favoris')
require('./picto-tablo-bord-matching')
require('./picto-tablo-bord-messagerie')
require('./picto-tablo-bord-parametres')
require('./picto-tablo-bord-profil')
require('./picto-tablo-bord-recherche')
require('./picto-tablo-bord-services')
require('./profile-user')
require('./refuse')
require('./renew')
require('./report')
require('./request-contact')
require('./right')
require('./sad')
require('./save')
require('./search')
require('./sendMessage')
require('./share')
require('./shield')
require('./signup')
require('./star')
require('./sub')
require('./super-sad')
require('./Triangle_Copy')
require('./umbrela')
require('./upload_file')
require('./upload')
require('./uploaded')
require('./user')
require('./valid-location-icon')
require('./visa')
require('./visibility')
require('./write')
